export default __webpack_public_path__ + "static/media/(15).a3ae71db.jpeg";